const familiariteNouveaute = {
  familiarite: "familiarite",
  nouveaute: "nouveaute",
  equilibre: "equilibre",
};

export default familiariteNouveaute;
